var map = {
	"./br/account": [
		81170,
		1170
	],
	"./br/account.json": [
		81170,
		1170
	],
	"./br/bets": [
		21673,
		1673
	],
	"./br/bets.json": [
		21673,
		1673
	],
	"./br/bonus": [
		58899,
		8899
	],
	"./br/bonus.json": [
		58899,
		8899
	],
	"./br/bookings": [
		65651,
		5651
	],
	"./br/bookings.json": [
		65651,
		5651
	],
	"./br/casino": [
		41303,
		1303
	],
	"./br/casino.json": [
		41303,
		1303
	],
	"./br/change-bet-settings": [
		65490,
		5490
	],
	"./br/change-bet-settings.json": [
		65490,
		5490
	],
	"./br/change-communication-settings": [
		34330,
		4330
	],
	"./br/change-communication-settings.json": [
		34330,
		4330
	],
	"./br/change-email": [
		25919,
		5919
	],
	"./br/change-email.json": [
		25919,
		5919
	],
	"./br/change-password": [
		11694,
		1694
	],
	"./br/change-password-recovery": [
		93683,
		3683
	],
	"./br/change-password-recovery.json": [
		93683,
		3683
	],
	"./br/change-password.json": [
		11694,
		1694
	],
	"./br/change-personal-data": [
		78594,
		8594
	],
	"./br/change-personal-data.json": [
		78594,
		8594
	],
	"./br/change-phone-number": [
		92090,
		2090
	],
	"./br/change-phone-number.json": [
		92090,
		2090
	],
	"./br/change-pin": [
		47211,
		7211
	],
	"./br/change-pin.json": [
		47211,
		7211
	],
	"./br/change-selflimits": [
		50937,
		937
	],
	"./br/change-selflimits.json": [
		50937,
		937
	],
	"./br/change-tfa-settings": [
		99714,
		9714
	],
	"./br/change-tfa-settings.json": [
		99714,
		9714
	],
	"./br/change-username": [
		11897,
		1897
	],
	"./br/change-username.json": [
		11897,
		1897
	],
	"./br/close-account": [
		14930,
		4930
	],
	"./br/close-account.json": [
		14930,
		4930
	],
	"./br/common": [
		41932,
		1932
	],
	"./br/common.json": [
		41932,
		1932
	],
	"./br/documents": [
		60019,
		19
	],
	"./br/documents.json": [
		60019,
		19
	],
	"./br/favorites": [
		52690,
		2690
	],
	"./br/favorites.json": [
		52690,
		2690
	],
	"./br/inquiry": [
		96341,
		6341
	],
	"./br/inquiry.json": [
		96341,
		6341
	],
	"./br/lock-account": [
		82704,
		2704
	],
	"./br/lock-account.json": [
		82704,
		2704
	],
	"./br/login": [
		43948,
		3948
	],
	"./br/login.json": [
		43948,
		3948
	],
	"./br/payment": [
		42547,
		2547
	],
	"./br/payment.json": [
		42547,
		2547
	],
	"./br/register": [
		80568,
		568
	],
	"./br/register.json": [
		80568,
		568
	],
	"./br/reset-password": [
		85842,
		5842
	],
	"./br/reset-password.json": [
		85842,
		5842
	],
	"./br/sports-search": [
		31165,
		1165
	],
	"./br/sports-search.json": [
		31165,
		1165
	],
	"./de/account": [
		34299,
		4299
	],
	"./de/account.json": [
		34299,
		4299
	],
	"./de/bets": [
		29029,
		9029
	],
	"./de/bets.json": [
		29029,
		9029
	],
	"./de/bonus": [
		15276,
		5276
	],
	"./de/bonus.json": [
		15276,
		5276
	],
	"./de/bookings": [
		47371,
		7371
	],
	"./de/bookings.json": [
		47371,
		7371
	],
	"./de/casino": [
		1210,
		1210
	],
	"./de/casino.json": [
		1210,
		1210
	],
	"./de/change-bet-settings": [
		94404,
		4404
	],
	"./de/change-bet-settings.json": [
		94404,
		4404
	],
	"./de/change-communication-settings": [
		83230,
		3230
	],
	"./de/change-communication-settings.json": [
		83230,
		3230
	],
	"./de/change-email": [
		97694,
		7694
	],
	"./de/change-email.json": [
		97694,
		7694
	],
	"./de/change-password": [
		31203,
		1203
	],
	"./de/change-password-recovery": [
		55925,
		5925
	],
	"./de/change-password-recovery.json": [
		55925,
		5925
	],
	"./de/change-password.json": [
		31203,
		1203
	],
	"./de/change-personal-data": [
		38181,
		8181
	],
	"./de/change-personal-data.json": [
		38181,
		8181
	],
	"./de/change-phone-number": [
		92751,
		2751
	],
	"./de/change-phone-number.json": [
		92751,
		2751
	],
	"./de/change-pin": [
		48800,
		8800
	],
	"./de/change-pin.json": [
		48800,
		8800
	],
	"./de/change-selflimits": [
		94269,
		4269
	],
	"./de/change-selflimits.json": [
		94269,
		4269
	],
	"./de/change-tfa-settings": [
		21972,
		1972
	],
	"./de/change-tfa-settings.json": [
		21972,
		1972
	],
	"./de/change-username": [
		34905,
		4905
	],
	"./de/change-username.json": [
		34905,
		4905
	],
	"./de/close-account": [
		44127,
		4127
	],
	"./de/close-account.json": [
		44127,
		4127
	],
	"./de/common": [
		21545,
		1545
	],
	"./de/common.json": [
		21545,
		1545
	],
	"./de/documents": [
		76518,
		6518
	],
	"./de/documents.json": [
		76518,
		6518
	],
	"./de/favorites": [
		52703,
		2703
	],
	"./de/favorites.json": [
		52703,
		2703
	],
	"./de/inquiry": [
		83091,
		3091
	],
	"./de/inquiry.json": [
		83091,
		3091
	],
	"./de/lock-account": [
		4084,
		4084
	],
	"./de/lock-account.json": [
		4084,
		4084
	],
	"./de/login": [
		22517,
		2517
	],
	"./de/login.json": [
		22517,
		2517
	],
	"./de/payment": [
		22404,
		2404
	],
	"./de/payment.json": [
		22404,
		2404
	],
	"./de/register": [
		7622,
		7622
	],
	"./de/register.json": [
		7622,
		7622
	],
	"./de/reset-password": [
		21565,
		1565
	],
	"./de/reset-password.json": [
		21565,
		1565
	],
	"./de/sports-search": [
		95410,
		5410
	],
	"./de/sports-search.json": [
		95410,
		5410
	],
	"./en/account": [
		61526,
		1526
	],
	"./en/account.json": [
		61526,
		1526
	],
	"./en/bets": [
		40479,
		479
	],
	"./en/bets.json": [
		40479,
		479
	],
	"./en/bonus": [
		11350,
		1350
	],
	"./en/bonus.json": [
		11350,
		1350
	],
	"./en/bookings": [
		55831,
		5831
	],
	"./en/bookings.json": [
		55831,
		5831
	],
	"./en/casino": [
		31698,
		1698
	],
	"./en/casino.json": [
		31698,
		1698
	],
	"./en/change-bet-settings": [
		24561,
		4561
	],
	"./en/change-bet-settings.json": [
		24561,
		4561
	],
	"./en/change-communication-settings": [
		12160,
		2160
	],
	"./en/change-communication-settings.json": [
		12160,
		2160
	],
	"./en/change-email": [
		91089,
		1089
	],
	"./en/change-email.json": [
		91089,
		1089
	],
	"./en/change-password": [
		90006,
		6
	],
	"./en/change-password-recovery": [
		27936,
		7936
	],
	"./en/change-password-recovery.json": [
		27936,
		7936
	],
	"./en/change-password.json": [
		90006,
		6
	],
	"./en/change-personal-data": [
		26997,
		6997
	],
	"./en/change-personal-data.json": [
		26997,
		6997
	],
	"./en/change-phone-number": [
		64018,
		4018
	],
	"./en/change-phone-number.json": [
		64018,
		4018
	],
	"./en/change-pin": [
		12522,
		2522
	],
	"./en/change-pin.json": [
		12522,
		2522
	],
	"./en/change-selflimits": [
		76101,
		6101
	],
	"./en/change-selflimits.json": [
		76101,
		6101
	],
	"./en/change-tfa-settings": [
		34953,
		88
	],
	"./en/change-tfa-settings.json": [
		34953,
		88
	],
	"./en/change-username": [
		76385,
		6385
	],
	"./en/change-username.json": [
		76385,
		6385
	],
	"./en/close-account": [
		51267,
		1267
	],
	"./en/close-account.json": [
		51267,
		1267
	],
	"./en/common": [
		40464,
		464
	],
	"./en/common.json": [
		40464,
		464
	],
	"./en/documents": [
		51626,
		1626
	],
	"./en/documents.json": [
		51626,
		1626
	],
	"./en/favorites": [
		5824,
		5824
	],
	"./en/favorites.json": [
		5824,
		5824
	],
	"./en/inquiry": [
		84286,
		4286
	],
	"./en/inquiry.json": [
		84286,
		4286
	],
	"./en/lock-account": [
		92391,
		6807
	],
	"./en/lock-account.json": [
		92391,
		6807
	],
	"./en/login": [
		16318,
		6318
	],
	"./en/login.json": [
		16318,
		6318
	],
	"./en/payment": [
		85106,
		5106
	],
	"./en/payment.json": [
		85106,
		5106
	],
	"./en/register": [
		97431,
		2946
	],
	"./en/register.json": [
		97431,
		2946
	],
	"./en/reset-password": [
		27840,
		7840
	],
	"./en/reset-password.json": [
		27840,
		7840
	],
	"./en/sports-search": [
		28045,
		8045
	],
	"./en/sports-search.json": [
		28045,
		8045
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;